import styled, { css } from 'styled-components'

export const KeyTitle = styled.span`
    color: var(--neutralcolor-dark);
    font-size: 1em;
    font-weight: 600;
    letter-spacing: 0.3px;
`
export const CustomizedTH = styled.th`
    ${({ alignTitles }) => {
        if (alignTitles === 'center') {
            return css`
                text-align: center;
            `
        }
    }}
`
